import { Button, Empty, Spin, Tag } from "antd";
import { useMemo } from "react";
import { safeJsonParse } from "../../../../../utils/shared";
import Summary from "./Summary";
import { StyledSummaries } from "./styles";
import { useSummaries } from "../../../../../hooks/useSummaries";
import CustomCollapse from "../../../../../components/generic/CustomDetails";
import { ReloadOutlined } from "@ant-design/icons";

const Summaries = () => {
  const { summaries, loading, fetchSummaries } = useSummaries();

  const groupedByDate = useMemo(() => {
    const groups = {};
    summaries.forEach((s) => {
      const date = new Date(s?.created_at);
      const dateKey = date?.toLocaleDateString("en-US", {
        day: "numeric",
        year: "numeric",
        month: "long",
      });
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }

      groups[dateKey].push({
        ...s,
        summary_text: safeJsonParse(s?.summary_text),
      });
    });
    return Object.entries(groups).sort(
      // @ts-ignore
      (a, b) => new Date(b[0]) - new Date(a[0]),
    );
  }, [summaries]);

  return (
    <StyledSummaries>
      {loading ? (
        <div className="w-100 flex justify-center  ">
          <Spin />
        </div>
      ) : (
        <div className="flex justify-center" style={{ marginBottom: "5px" }}>
          <Button
            icon={<ReloadOutlined />}
            type="primary"
            size="small"
            onClick={() => fetchSummaries(true)}
          >
            Refresh
          </Button>
        </div>
      )}

      {!loading && summaries?.length === 0 && (
        <Empty description="No Summaries found" />
      )}
      {groupedByDate.map(([dateKey, sum]) => (
        <CustomCollapse
          title={dateKey}
          titleClass="summaries-date"
          //@ts-ignore
          headerRight={
            <Tag className="group-meta" color="blue">
              {`${sum?.length || 1} ${(sum?.length || 1) === 1 ? "summary" : "summaries"}`}
            </Tag>
          }
        >
          <div className="summaries-list">
            {sum.map((summary, i) => (
              <Summary data={summary} key={i} />
            ))}
          </div>
        </CustomCollapse>
      ))}
    </StyledSummaries>
  );
};

export default Summaries;
